(function () {
  'use strict';

  /* Summer deals carousel */
  document.querySelectorAll('[data-rm-deals]').forEach(function (root) {
    var track = root.querySelector('.rm-hb-deals__track');
    var prev = root.querySelector('[data-deals-prev]');
    var next = root.querySelector('[data-deals-next]');
    if (!track) return;
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -648, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: 648, behavior: 'smooth' }); });
  });

  /* Countdown in deals header */
  var cdRoot = document.getElementById('rm-hb-countdown');
  if (cdRoot) {
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      var diff = Math.max(0, Math.floor((end.getTime() - Date.now()) / 1000));
      var h = cdRoot.querySelector('[data-cd-h]');
      var m = cdRoot.querySelector('[data-cd-m]');
      var s = cdRoot.querySelector('[data-cd-s]');
      if (h) h.textContent = pad(Math.floor(diff / 3600));
      if (m) m.textContent = pad(Math.floor((diff % 3600) / 60));
      if (s) s.textContent = pad(diff % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* FAQ accordion */
  document.querySelectorAll('.rm-hb-faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.rm-hb-faq__item');
      if (!item) return;
      var open = item.classList.contains('is-open');
      item.closest('.rm-hb-faq__list').querySelectorAll('.rm-hb-faq__item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('.rm-hb-faq__q').setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Quick add on deal cards */
  document.querySelectorAll('.rm-hb-deal__add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-variant-id');
      var url = btn.getAttribute('data-product-url');
      if (btn.getAttribute('data-multi-variant') === 'true' && url) {
        window.location.href = url;
        return;
      }
      if (!id || btn.disabled) return;
      btn.disabled = true;
      fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).then(function (r) { return r.json(); }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }).catch(function () {
        if (url) window.location.href = url;
      }).finally(function () {
        btn.disabled = false;
      });
    });
  });
})();

/* Reviews marquee — continu auto-scroll, stopt bij hover, en handmatig scrolbaar/sleepbaar.
   Neemt de CSS-marquee over met scrollLeft zodat de rij ook met muis/trackpad/touch
   te scrollen is en niet doodloopt (o.a. bij 'verminder beweging'). */
(function () {
  'use strict';

  var masks = document.querySelectorAll('.rm-hb-reviews__mask');
  if (!masks.length) return;

  var STYLE_ID = 'rm-rev-marquee-style';
  if (!document.getElementById(STYLE_ID)) {
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent =
      '.rm-hb-reviews__mask{overflow-x:auto;overflow-y:hidden;cursor:grab;scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}' +
      '.rm-hb-reviews__mask::-webkit-scrollbar{display:none;}' +
      '.rm-hb-reviews__mask.is-dragging{cursor:grabbing;}' +
      '.rm-hb-reviews__mask .rm-hb-reviews__track{animation:none !important;}';
    document.head.appendChild(st);
  }

  masks.forEach(function (mask) {
    var track = mask.querySelector('.rm-hb-reviews__track');
    if (!track) return;

    var SPEED = 0.5;                 // px per frame ≈ 30px/s
    var paused = false;
    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var resumeTimer = null;

    function half() { return mask.scrollWidth / 2; }   // breedte van één groep (er staan 2 identieke groepen)

    function wrap() {
      var h = half();
      if (h <= 0) return;
      if (mask.scrollLeft >= h) mask.scrollLeft -= h;
      else if (mask.scrollLeft < 0) mask.scrollLeft += h;
    }

    function step() {
      if (!paused && !dragging) {
        mask.scrollLeft += SPEED;
        wrap();
      }
      requestAnimationFrame(step);
    }

    function pauseFor(ms) {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, ms);
    }

    /* Stop bij hover */
    mask.addEventListener('mouseenter', function () { paused = true; clearTimeout(resumeTimer); });
    mask.addEventListener('mouseleave', function () { if (!dragging) paused = false; });

    /* Pauzeer tijdens handmatig scrollen, hervat daarna */
    mask.addEventListener('wheel', function () { pauseFor(1500); }, { passive: true });
    mask.addEventListener('touchstart', function () { paused = true; clearTimeout(resumeTimer); }, { passive: true });
    mask.addEventListener('touchend', function () { pauseFor(1500); }, { passive: true });

    /* Sleep-om-te-scrollen (muis/pen) */
    mask.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // touch gebruikt native scroll
      dragging = true; moved = false; paused = true;
      startX = e.clientX; startScroll = mask.scrollLeft;
      mask.classList.add('is-dragging');
      try { mask.setPointerCapture(e.pointerId); } catch (err) {}
    });
    mask.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      mask.scrollLeft = startScroll - dx;
      wrap();
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      mask.classList.remove('is-dragging');
      pauseFor(800);
    }
    mask.addEventListener('pointerup', endDrag);
    mask.addEventListener('pointercancel', endDrag);
    mask.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    /* Houd handmatig scrollen binnen de loop */
    mask.addEventListener('scroll', wrap, { passive: true });

    requestAnimationFrame(step);
  });
})();

/* Bekend van logo-marquee — naadloze loop + pauze bij hover (2026-07-20).
   De oude CSS-marquee (translateX -50%) liep leeg zodra één helft smaller was
   dan het scherm, en de sprong aan het eind zag je omdat de "stap" niet paste.
   We vullen nu elke helft met genoeg kopieën zodat één helft breder is dan de
   viewport; dan loopt translateX(-50%) rond zonder lege plek en zonder sprong.
   De snelheid blijft gelijk doordat de duur meeschaalt met het aantal kopieën.
   Pauze bij hover zetten we hard via een geïnjecteerde stijl. */
(function () {
  'use strict';

  var strips = document.querySelectorAll('.rm-hb-bvk');
  if (!strips.length) return;

  var STYLE_ID = 'rm-bvk-marquee-style';
  if (!document.getElementById(STYLE_ID)) {
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent =
      '.rm-hb-bvk__mask:hover .rm-hb-bvk__track,' +
      '.rm-hb-bvk__track:hover{animation-play-state:paused;}';
    document.head.appendChild(st);
  }

  var BASE_SECONDS = 32; // duur van de originele CSS-animatie bij 1 kopie per helft

  strips.forEach(function (strip) {
    var track = strip.querySelector('.rm-hb-bvk__track');
    if (!track) return;
    var groups = track.querySelectorAll('.rm-hb-bvk__group');
    if (!groups.length) return;

    groups.forEach(function (g) {
      if (!g.dataset.bvkBase) g.dataset.bvkBase = g.innerHTML;
    });

    function fill() {
      groups.forEach(function (g) { g.innerHTML = g.dataset.bvkBase; });
      var base = groups[0].scrollWidth || 1;
      var need = Math.max(1, Math.ceil((window.innerWidth * 1.25) / base));
      if (need > 1) {
        groups.forEach(function (g) {
          var html = '';
          for (var i = 0; i < need; i++) html += g.dataset.bvkBase;
          g.innerHTML = html;
        });
      }
      track.style.animationDuration = (BASE_SECONDS * need) + 's';
    }

    fill();

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(fill, 200);
    });
  });
})();
